<style>
.list-group-item2 {
    position: relative;
    /* display: block; */
    padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
    color: var(--bs-list-group-color);
    text-decoration: none;
    background-color: var(--bs-list-group-bg);
    border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
</style>
<template>
    <div class="app-layout">
        <!-- Componente de la barra de navegación -->
        <NavBar :collapsed="collapsed" :pinned="pinned" @update:collapsed="updateCollapsed"
            @update:pinned="updatePinned" />
        <!-- Contenido principal -->

        <main :class="{ 'main-collapsed': collapsed, 'main-expanded': !collapsed || pinned }">
            <BarTop />
            <div class="pt-2 px-3">
                <div class="py-4">
                    <h2 class="">Estados de cuenta</h2>
                    <p>Lista de todos los pagos a proveedores y servicios pendientes de cobro.
                        Los pagos corresponden a los realizados a aduanas, navieras y administradores varios para
                        efectuar los despachos.
                        Los servicios son cobros por la gestión de los despachos.
                    </p>
                </div>
                <div>
                    <p>Filtros</p>
                    <div class="text-end">
                        <div class=" mt-4 mx-4">
                            <span class="mx-1">
                                <a class="btn btn-success" @click="filter()">Filtrar</a>
                            </span>
                            <a class="btn btn-success" @click="deleteFilters()">Limpiar filtros</a>
                        </div>
                    </div>
                    <div class="m-3 row">
                        <div class="col-md-2 mb-4">
                            <label for="rut" class="form-label">Rut cliente</label>
                            <input type="text" class="form-control" :class="{ 'border-danger': dataForm.rut.err }"
                                id="rut" placeholder="Use solo números y guión" @input="handleRutInput"
                                v-model="dataForm.rut.value">
                            <span v-if="dataForm.rut.err" class="text-danger">Debe ingresar un
                                rut</span>
                        </div>

                        <div class="col-md-2 mb-4">
                            <label for="shipping_number" class="form-label">Nro despacho</label>
                            <input type="text" class="form-control"
                                :class="{ 'border-danger': dataForm.shipping_number.err }" id="shipping_number"
                                placeholder="" v-model="dataForm.shipping_number.value">
                            <span v-if="dataForm.shipping_number.err" class="text-danger">Debe ingresar un
                                número de despacho</span>
                        </div>
                        <div class="col-md-2 mb-4">
                            <label for="booking_number" class="form-label">Nro reserva</label>
                            <input type="text" class="form-control"
                                :class="{ 'border-danger': dataForm.booking_number.err }" id="booking_number"
                                placeholder="" v-model="dataForm.booking_number.value">
                            <span v-if="dataForm.booking_number.err" class="text-danger">Debe ingresar un
                                número de reserva</span>
                        </div>

                        <div class="col-md-2 mb-4">
                            <label for="bill_number" class="form-label">Nro nota cobro</label>
                            <input type="text" class="form-control"
                                :class="{ 'border-danger': dataForm.bill_number.err }" id="bill_number" placeholder=""
                                v-model="dataForm.bill_number.value">
                            <span v-if="dataForm.bill_number.err" class="text-danger">Debe ingresar un
                                número de nota cobro</span>
                        </div>
                        <div class="col-md-2 mb-4">
                            <label for="document_number" class="form-label">Nro de factura</label>
                            <input type="text" class="form-control"
                                :class="{ 'border-danger': dataForm.document_number.err }" id="document_number"
                                placeholder="" v-model="dataForm.document_number.value">
                            <span v-if="dataForm.document_number.err" class="text-danger">Debe ingresar un
                                número de documento</span>
                        </div>
                        <div class="col-md-2 mb-4">
                            <label for="document_type" class="form-label">Tipo</label>
                            <select id="sel_tipo_servicio" class="form-select" placeholder="seleccione un tipo"
                                aria-label="Default select example" v-model="dataForm.id_table_type.value">
                                <option value="">Ver todos</option>
                                <option :value="1">Servicio por cobrar</option>
                                <option :value="3">Nota de cobro</option>
                            </select>
                        </div>
                        <div class="col-md-2 mb-4">
                            <label for="amount" class="form-label">Monto deuda original</label>
                            <input type="text" class="form-control" :class="{ 'border-danger': dataForm.amount.err }"
                                id="amount" placeholder="" v-model="dataForm.amount.value">
                            <span v-if="dataForm.amount.err" class="text-danger">Debe ingresar un monto</span>
                        </div>

                        <div class="col-md-7 mt-4">
                            <div>
                                <a class="btn btn-success" @click="abrirModalClientes()">Seleccionar clientes</a>
                            </div>
                            <span v-if="filtrandoClientes" class="text-danger">Filtro por clientes activado</span>
                        </div>
                        <div class="col-md-3 mb-4 pb-3 align-items-end">
                            <div class="form-check">
                                <input class="form-check-input" type="checkbox" id="chk_only_unpaid"
                                    v-model="dataForm.only_unpaid.value" />
                                <label class="form-check-label" for="chk_only_unpaid">
                                    Mostrar solo impagos (&gt; 0)
                                </label>
                            </div>
                        </div>
                    </div>




                    <div class="text-end mb-3">
                        <button class="btn btn-primary me-2" @click="exportToExcel">
                            <i class="bi bi-file-earmark-spreadsheet me-1"></i> Descargar Excel
                        </button>
                        <button class="btn btn-danger" @click="exportZip">
                            <i class="bi bi-file-earmark-pdf me-1"></i> Descargar PDF
                        </button>
                    </div>
                    <vue3-datatable :no-data-content="'No se encontraron resultados.'" :search="search" :rows="items"
                        :columns="columns" order :sortable="true" :sort-column="sortColumn"
                        :sort-direction="sortDirection" :is-server-mode="true" :page="page" :page-size="perPage"
                        :total-rows="totalRows" :loading="loading" @change="onTableChange" >
                    <!-- tus slots tal cual -->
                    <template #amount="data">
                        <span>{{ data.value.amount > 0 ? formatCurrency(data.value.amount, data.value.initials) : 0
                            }}</span>
                    </template>
                    <template #monto_con_iva="data">
                        <span>{{ data.value.monto_con_iva > 0 ? formatCurrency(data.value.monto_con_iva, data.value.initials) : 0
                            }}</span>
                    </template>
                    <template #value_payment="data">
                        <span>{{ data.value.value_payment > 0 ? formatCurrency(data.value.value_payment,
                            data.value.value_payment_initials) : 0 }}</span>
                    </template>
                    <template #impago_actual_con_iva="data">
                        <span>{{ data.value.impago_actual_con_iva > 0 ? formatCurrency(data.value.impago_actual_con_iva,
                            data.value.initials) : 0 }}</span>
                    </template>
                    <template #rut="row">
                        <td style=" text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                    </template>
                    <template #table_type="row">
                        <td style=" text-align: end; white-space: nowrap;">{{ row.value.id_table_meta_type == 1 ?
                            'Servicio por cobrar' : 'Nota de cobro' }}</td>
                    </template>
                    <template #date="row">
                        <td style=" text-align: end; white-space: nowrap;">{{ row.value.date }}</td>
                    </template>
                    <template #actions="data">
                        <!-- sin cambios -->
                    </template>
                    </vue3-datatable>
                </div>
            </div>
        </main>
        <!-- Historial-->
        <div class="modal-mb" v-if="verHistorial">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class=" text-black col-11" id="exampleModalLabel">Historial de pagos</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal()"
                            aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card">
                            <div class="row mx-4">
                                <div class="col-md-4 mb-4" v-if="tipoHistory == 3">
                                    <label for="historialType" class="form-label">Tipo</label>
                                    <select class="form-select" placeholder="seleccione un tipo"
                                        aria-label="Default select example" v-model="historialType">
                                        <option value="">Ver todos</option>
                                        <option :value="7">pago a proveedor (abono directo)</option>
                                        <option :value="8">pago a proveedor (abono por provisión)</option>
                                    </select>
                                </div>
                                <div class="col-md-4 mb-4" v-if="tipoHistory == 1">
                                    <label for="historialType" class="form-label">Tipo</label>
                                    <select class="form-select" placeholder="seleccione un tipo"
                                        aria-label="Default select example" v-model="historialType">
                                        <option value="">Ver todos</option>
                                        <option :value="1">Servicio por cobrar</option>
                                        <option :value="5">Servicio por cobrar (abono directo)</option>
                                        <option :value="6">Servicio por cobrar (abono por provisión)</option>
                                    </select>
                                </div>

                                <div class="col-md-2 mt-4">
                                    <div class="text-end">
                                        <a class="btn btn-success" @click="filterHistory()">Filtrar</a>
                                    </div>
                                </div>
                            </div>
                            <div class="">
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                    :rows="payments" :columns="columns2" order :sortable="true" :sortColumn="'ID'">
                                    <template #id_balance="data">
                                        <span v-if="data.value.id_balance">
                                            {{ data.value.id_balance }}
                                        </span>
                                        <span v-if="data.value.id_payment_balance">
                                            {{ data.value.id_payment_balance }}
                                        </span>
                                    </template>
                                    <template #amount="data">
                                        <span>{{
            formatCurrency(data.value.amount, data.value.initials) }}</span>
                                    </template>

                                    <template #value_payment="data">
                                        <span v-if="data.value.value_payment != 0">{{
            formatCurrency(data.value.value_payment, data.value.value_payment_initials)
        }}</span>
                                        <span v-else>{{
                formatCurrency(0.00, data.value.initials) }}</span>
                                    </template>

                                    <template #unpaid_amount="data">
                                        <span v-if="data.value.unpaid_amount != 0">{{
            formatCurrency(data.value.unpaid_amount, data.value.value_unpaid_initials)
        }}</span>
                                        <span v-else>{{
                formatCurrency(0.00, data.value.initials) }}</span>
                                    </template>
                                    <template #rut="row">
                                        <td style=" text-align: end; white-space: nowrap;">{{ row.value.rut }}</td>
                                    </template>
                                    <!-- Celda personalizada -->
                                    <template #date="row">
                                        <td style="text-align: end; white-space: nowrap;">{{ row.value.date }}</td>
                                    </template>
                                    <template #select="data">
                                        <button @click="toggleSelectionBoard(data.value)">
                                            {{ isSelectedBoard(data.value) ? 'Desasociar' : 'Asociar' }}
                                        </button>
                                    </template>
                                </vue3-datatable>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>
        <!-- Ver -->
        <div class="modal-mb" v-if="verModal">
            <div class="modal-dialo bg-white">
                <div class="modal-content">
                    <div class="modal-header row">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Servicio por Cobrar</h5>
                        <button type="button" class="btn-close col" data-bs-dismiss="modal" @click="closeModal2()"
                            aria-label="Cerrar"></button>
                    </div>
                    <div class="modal-body mt-4">
                        <div class="card p-4">
                            <div class="row">
                                <div class="col-md-4">
                                    <b>ID</b>
                                    <p>{{ service.id_payment != 0 ? service.id_payment : service.id_cs_fee }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de despacho</b>
                                    <p>{{ service.id_shipping }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Estado</b>
                                    <p>{{ service.status_name }}</p>
                                </div>

                                <div class="col-md-4">
                                    <b>Fecha de creación</b>
                                    <p>{{ service.date }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>RUT del cliente</b>
                                    <p>{{ service.rut }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto de deuda original</b>
                                    <p>{{ service.amount > 0 ? formatCurrency(service.amount, service.initials) : 0 }}
                                    </p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto deuda abonado</b>
                                    <p>{{ service.value_payment > 0 ? formatCurrency(service.value_payment,
            service.value_payment_initials) : 0 }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Monto impago</b>
                                    <p>{{ service.unpaid_amount > 0 ? formatCurrency(service.unpaid_amount,
            service.initials) :
            0 }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de factura</b>
                                    <p>{{ service.bill_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de despacho</b>
                                    <p>{{ service.shipping_number }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de reserva</b>
                                    <p>{{ service.booking_number }}</p>
                                </div>
                            </div>
                            <br><br>
                            <h6 v-if="service.bank_account_origin">Datos del pago efectuado al momento de abonar</h6>
                            <br>
                            <div class="row">
                                <div class="col-md-4">
                                    <b>Banco</b>
                                    <p>{{ service.bank }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Método de pago</b>
                                    <p>{{ service.payment_method == 1 ? 'Transferencia electrónica' : '' }}</p>
                                </div>
                                <div class="col-md-4">
                                    <b>Número de cuenta</b>
                                    <p>{{ service.bank_account_origin }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModal2()">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>


        <!-- Seleccionar clientes para filtrado-->
        <div class="modal-mb " v-if="verClientes">
            <div class="modal-dialo bg-white col-md-6 mb-8">
                <div class="modal-content ">
                    <div class="modal-header row ">
                        <h5 class="modal-title text-black col-11" id="exampleModalLabel">Clientes</h5>

                        <button type="button" class="btn-close col" data-bs-dismiss="modal"
                            @click="closeModalClientes()" aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-4 ">
                        <div class="card">
                            <div>
                                <vue3-datatable :noDataContent="'No se encontraron resultados.'" :search="search"
                                    :rows="clients" :columns="col_clients" order :sortable="true" :sortColumn="'ID'"
                                    v-if="renderComponent">
                                    <template #id_client="data">
                                        <div>
                                            <span>{{ data.value.id_client }}</span>
                                        </div>
                                    </template>
                                    <template #name="data">
                                        <div>
                                            <span>{{ data.value.name }}</span>
                                        </div>
                                    </template>
                                    <template #rut="data">
                                        <div>
                                            <span>{{ data.value.rut }}</span>
                                        </div>
                                    </template>
                                    <template #filtrar="data">
                                        <div>
                                            <input type="checkbox" :key="[data.value.id_client] + 'chk'"
                                                :id="[data.value.id_client] + 'chk'" v-model="data.value.filtrar"
                                                @click="toogleFiltraCliente($event, data.value)" />

                                        </div>
                                    </template>


                                </vue3-datatable>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer mt-3">

                        <div class="me-2">
                            <a class="btn btn-success" @click="closeFilterModalClientes()">Filtrar</a>
                        </div>

                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                            @click="closeModalClientes()">Cerrar</button>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import Vue3Datatable from "@bhplugin/vue3-datatable";
import NavBar from './../component/NavBar.vue';
import BarTop from './../component/BarTop.vue';
/** Librerías para exportar Excel y PDF **/
import * as XLSX from 'xlsx';             // Para Excel
import { saveAs } from 'file-saver';      // Para forzar la descarga de archivos
import jsPDF from 'jspdf';                // Para PDF
import autoTable from 'jspdf-autotable';  // Para crear tablas en el PDF
import { nextTick, ref } from 'vue';
import JSZip from 'jszip'



export default {
    components: {
        VueDatePicker,
        Vue3Datatable,
        NavBar,
        BarTop
    },
    data() {
        return {
            loading: false,
            search: '',
            page: 1,            // página actual
            perPage: 10,        // filas por página
            totalRows: 0,       // total que viene del backend
            sortColumn: 'date_origin',  // o el campo por defecto que ya usas
            sortDirection: 'desc',
            renderComponent: true,
            collapsed: true,
            pinned: localStorage.getItem('pinned') == 'false' ? false : true || false,
            theme: localStorage.getItem('theme') || 'light-mode',
            options: {
                responsive: true,
                maintainAspectRatio: false,
            },
            tipoHistory: 0,
            historialType: '',
            idHistory: 0,
            service: {},
            verModal: false,
            dataForm: {
                rut: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                only_unpaid: { value: true, err: false, msjErr: '' },
                shipping_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                booking_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                bill_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                document_number: {
                    value: '',
                    err: false,
                    msjErr: ''
                },
                id_table_type: {
                    value: "",
                    err: false,
                    msjErr: ''
                },
                amount: {
                    value: 0,
                    err: false,
                    msjErr: ''
                },
            },
            currentItems: [],
            verHistorial: false,
            items: [],
            clients: [],
            old_clients: [],
            verClientes: false,
            filtrandoClientes: false,
            col_clients: [
                { field: "id_client", title: "ID", filter: false },
                { field: "name", title: "Nombre" },
                { field: "rut", title: "RUT" },
                { field: "filtrar", title: 'Filtrar', sortable: false }
            ],

            columns: [
                { field: "shipping_number", title: "Número Despacho" },
                { field: "booking_number", title: "Número Reserva" },
                { field: "date_origin", title: "Fecha" },
                { field: "week_number_origin", title: "Semana" },
                { field: "id_billing_note", title: "Nota de Cobro" },
                { field: "bill_number", title: "Número de Factura" },
                { field: "table_type", title: "Tipo" },
                { field: "status_name", title: "Estado" },
                { field: "rut", title: "RUT" },
                { field: "concept", title: "Concepto" },
                { field: "amount", title: "Monto Neto" },
                { field: "monto_con_iva", title: "Monto Total con IVA" },
                { field: "value_payment", title: "Último monto abonado" },
                { field: "date", title: "Fecha último abono" },
                { field: "impago_actual_con_iva", title: "Monto impago actual" },
                { field: "actions", title: "" }
            ],
            columns2: [
                { field: "id_balance", title: "ID" },
                { field: "shipping_number", title: "Nº despacho" },
                { field: "booking_number", title: "Nº reserva" },
                { field: "date", title: "Fecha" },
                { field: "week_number", title: "Número de semana" },
                { field: "table_type", title: "Tipo" },
                { field: "bill_number", title: "Nota de cobro" },
                { field: "rut", title: "RUT cliente" },
                { field: "status_name", title: "Estado" },
                { field: "concept", title: "Concepto" },
                { field: "amount", title: "Monto deuda original" },
                { field: "value_payment", title: "Monto abonado" },
                { field: "unpaid_amount", title: "Monto impago" },
                { field: "bank_account_origin", title: "Cuenta de origen" },
                { field: "bank", title: "Banco" },
                { field: "payment_method", title: "Método de pago" }
            ]
        }
    },
    async mounted() {
        await this.getAR();
        await this.getClients();
        this.$swal.close(); // con await hay que cerrar al final acá
        document.body.className = this.theme;

    },
    computed: {

    },
    methods: {
        async fetchAllReceivablesForExport() {
            // usa exactamente los mismos filtros/orden que tu tabla
            const base = {
                rut: this.dataForm.rut.value,
                tipo: this.dataForm.id_table_type.value,
                nroDespacho: this.dataForm.shipping_number.value,
                booking_number: this.dataForm.booking_number.value,
                nroFactura: this.dataForm.document_number.value,
                monto: this.dataForm.amount.value,
                bill_number: this.dataForm.bill_number.value,
                clientes: this.getClientesFiltrados(),
                solo_impagos: this.dataForm.only_unpaid.value,
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            const all = [];
            let page = 1;
            const PER_PAGE = 1000; // ajusta si tu API permite más
            let total = Infinity;

            // opcional: feedback de progreso
            this.$swal({ title: 'Preparando exportación...', text: 'Cargando registros', allowOutsideClick: false });
            this.$swal.showLoading();

            while (all.length < total) {
                const params = { ...base, page, per_page: PER_PAGE };
                const { data, status } = await axios.post('/api/getReceivablesFilterBn', params, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                if (status !== 200) break;

                const rows = data?.data || [];
                total = Number(data?.total ?? rows.length);
                all.push(...rows);

                // rompe bucle de seguridad si el backend no trae total
                if (!rows.length) break;

                page += 1;
                // (opcional) actualiza el texto con el avance:
                this.$swal.update({ title: 'Preparando exportación...', text: `Cargados ${all.length} de ${isFinite(total) ? total : '...'}` });
            }

            this.$swal.close();
            return all;
        },
        onTableChange(payload) {
            // mira qué llega
            console.log('change payload =>', payload);
            this.page = payload.current_page;
            this.perPage = payload.pagesize;
            this.sortColumn = payload.sort_column;
            this.sortDirection = payload.sort_direction;

            // ahora sí llama al backend con los valores nuevos
            this.filter();
        },
        async forceRerender() {
            // Remove MyComponent from the DOM
            this.renderComponent = false;

            // Wait for the change to get flushed to the DOM
            await this.$nextTick();

            // Add the component back in
            this.renderComponent = true;
        },

        editPaymentOrCssFee(data) {

            if (data["id_cs_fee"] != 0) {
                window.location.href = '/serviciosCobrar/' + data.id_cs_fee;
            } else {
                window.location.href = '/pagoProveedores/crear/' + data.id_payment;
            }
        },
        formatDateOnly(s) {
            if (!s) return '';
            // intenta parsear; si falla, cae a split
            const iso = s.replace(' ', 'T'); // "YYYY-MM-DD HH:mm:ss" -> "YYYY-MM-DDTHH:mm:ss"
            const d = new Date(iso);
            if (!isNaN(d.getTime())) {
                return d.toLocaleDateString('es-CL'); // ej: 13-08-2025 según locale
            }
            // fallback simple
            return s.split(' ')[0]; // "YYYY-MM-DD"
        },
        async addPartialPayment(data) {
            try {

                if (data.id_table_meta_type == 1) {
                    this.$swal({
                        title: "¿Deseas abonar este pago?",
                        showDenyButton: true,
                        showCancelButton: true,
                        confirmButtonText: "Abonar",
                        cancelButtonText: 'Cancelar',
                        denyButtonText: `Abonar desde provisiones`
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            window.location.href = 'serviciosCobrar/abonar/' + data.id_cs_fee + '/' + data.id_client;
                        } else if (result.isDenied) {
                            this.getSupply(data, 2)
                            window.location.href = 'serviciosCobrar/provisionabonar/' + data.id_cs_fee + '/' + data.id_client;
                        }
                    });

                } else {
                    let showBtn = true;
                    let nota = "";
                    if (data.emitted_notes == "") {
                        showBtn = false;
                        nota = "Pago sin nota de cobro emitida, ";
                        nota += " abonos directos deshabilitados.";
                    }
                    this.$swal({
                        title: "¿Deseas abonar este pago?",
                        text: nota,
                        showDenyButton: true,
                        showCancelButton: true,
                        showConfirmButton: showBtn,
                        confirmButtonText: "Abonar",
                        cancelButtonText: 'Cancelar',
                        denyButtonText: `Abonar desde provisiones`
                    }).then((result) => {
                        /* Read more about isConfirmed, isDenied below */
                        if (result.isConfirmed) {
                            window.location.href = 'pagoProveedores/abonar/' + data.id_payment + '/' + data.id_client;
                        } else if (result.isDenied) {

                            this.getSupply(data, 1)
                        }
                    });
                }

            } catch (error) {
                console.error('Error fetching concepts:', error);
            }

        },
        async getSupply(data, tipo) {
            const self = this;
            try {
                const response = await axios.get('/api/clientSupply/' + data.id_client, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                    }
                });
                let supply = response.data; // Array de objetos con el campo "amount"

                // Suma de todos los amounts (asegurándonos de que sean numéricos)
                let totalAmount = supply.reduce((acc, item) => {
                    return acc + Number(item.amount);
                }, 0);

                if (totalAmount > 0) {
                    if (tipo == 1) {
                        window.location.href = 'pagoProveedores/provisionabonar/' + data.id_payment + '/' + data.id_client;
                    } else {
                        window.location.href = 'serviciosCobrar/provisionabonar/' + data.id_cs_fee + '/' + data.id_client;
                    }

                } else {
                    // Muestra mensaje si no hay saldo
                    this.$swal.fire({
                        icon: 'info',
                        title: 'Sin saldo disponible',
                        text: 'No cuentas con saldo en tus provisiones',
                        confirmButtonText: 'OK'
                    });
                }

            } catch (error) {
                console.error('Error fetching supply:', error);
            }
        },

        getClientesFiltrados() {
            let self = this;
            let filtrados = self.clients.filter((client) => client.filtrar == true);

            let ids_clientes = filtrados.map((client) => {
                return client.id_client;
            });
            return ids_clientes;
        },

        async toogleFiltraCliente(event, clientData) {
            clientData.filtrar = !clientData.filtrar;
            this.forceRerender(); // checkbox no se actualiza sin esto
            // console.log(this.getClientesFiltrados());
        },

        async delFiltroClientes() {
            this.clients = this.clients.map((clientData) => {
                clientData.filtrar = false;
                return clientData;
            });
            this.old_clients = this.old_clients.map((clientData) => {
                clientData.filtrar = false;
                return clientData;
            });

            this.filtrandoClientes = false;
        },

        async deleteFilters() {

            document.getElementById("sel_tipo_servicio").value = "";
            this.dataForm.id_table_type.value = "";

            document.getElementById("document_number").value = "";
            this.dataForm.document_number.value = "";

            document.getElementById("bill_number").value = "";
            this.dataForm.bill_number.value = "";

            document.getElementById("booking_number").value = "";
            this.dataForm.booking_number.value = "";

            document.getElementById("shipping_number").value = "";
            this.dataForm.shipping_number.value = "";

            document.getElementById("rut").value = "";
            this.dataForm.rut.value = "";

            document.getElementById("amount").value = "0";
            this.dataForm.amount.value = "0";

            this.dataForm.only_unpaid.value = true;

            this.delFiltroClientes();
            this.page = 1;
            this.filter();
        },

        async filterHistory() {
            let id = this.idHistory;
            let self = this;
            self.verHistorial = false;

            this.$swal({
                title: 'Obteniendo historial de abonos'
            });
            this.$swal.showLoading();
            try {
                let params = {
                    tipo: this.historialType
                }
                if (this.tipoHistory == 1) {
                    const response = await axios.post('/api/services-history-noship/' + id, params, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });
                    if (response) {
                        this.$swal.close();
                        self.verHistorial = true;
                    }
                    self.payments = response.data.data;
                } else {

                    const response = await axios.post('/api/getHistoryBn/' + id, params, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });
                    if (response) {
                        this.$swal.close();
                        self.verHistorial = true;
                    }
                    self.payments = response.data.data;
                }

            } catch (error) {
                console.error('Error fetching concepts:', error);
            }
        },

        async showHistorial(value) {
            this.tipoHistory = value.id_table_meta_type;

            this.historialType = '';
            let params = {
                tipo: ''
            }
            try {

                if (value.id_table_meta_type == 1) {
                    this.idHistory = value.id_cs_fee;
                    const response = await axios.post('/api/services-history-noship/' + value.id_cs_fee, params, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });
                    this.payments = response.data.data;

                } else {
                    this.idHistory = value.id_billing_note;
                    const response = await axios.post('/api/getHistoryBn/' + value.id_billing_note, params, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                        }
                    });
                    this.payments = response.data.data;

                }


                this.verHistorial = true;

            } catch (error) {
                console.error('Error fetching concepts:', error);
            }

        },
        showService(value) {
            this.verModal = true;
            this.service = value;
        },
        closeModal2() {
            this.verModal = false;
        },
        closeModal() {
            this.verHistorial = false;
        },
        closeModalClientes() {
            // cerrar cancelando cambios
            this.clients = this.old_clients;
            if (this.getClientesFiltrados().length > 0) {
                this.filtrandoClientes = true;
            } else {
                this.filtrandoClientes = false;
            }
            this.verClientes = false;
        },

        closeFilterModalClientes() {
            // cerrar y filtrar
            this.old_clients = this.clients;
            if (this.getClientesFiltrados().length > 0) {
                this.filtrandoClientes = true;
            } else {
                this.filtrandoClientes = false;
            }
            this.page = 1;
            this.verClientes = false;
            this.filter();
        },

        abrirModalClientes() {
            this.verClientes = true;
            // esto funciona solo cuando a js se le da la gana
            //this.old_clients = structuredClone(this.clients);

            // guarda versión anterior
            this.old_clients = this.clients.map((clientData) => {
                var clientdata = {
                    "id_client": clientData.id_client,
                    "rut": clientData.rut,
                    "filtrar": structuredClone(clientData.filtrar),
                    "name": clientData.name
                };
                return clientdata;
            });
        },

        formatCurrency(value, currencyCode = 'CLP') {
            return new Intl.NumberFormat('es-CL', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0 // O puedes cambiar el valor según lo que necesites
            }).format(value);
        },
        updateCollapsed(value) {

            this.collapsed = value; // Actualiza el estado
        },
        updatePinned(value) {

            this.pinned = value; // Actualiza el estado
        },
        showreq(id) {
            const self = this;

        },
        filter() {
            console.log("aca");
            console.log('LLAMANDO BACKEND', { page: this.page, perPage: this.perPage, sort: this.sortColumn, dir: this.sortDirection });
            this.loading = true;

            const ids_clientes = this.getClientesFiltrados();

            const params = {
                per_page: this.perPage,
                page: this.page,
                rut: this.dataForm.rut.value,
                tipo: this.dataForm.id_table_type.value,
                nroDespacho: this.dataForm.shipping_number.value,
                booking_number: this.dataForm.booking_number.value,
                nroFactura: this.dataForm.document_number.value,
                monto: this.dataForm.amount.value,
                bill_number: this.dataForm.bill_number.value,
                clientes: ids_clientes,
                solo_impagos: this.dataForm.only_unpaid.value,
                // opcional (si tu backend acepta)
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            axios.post('/api/getReceivablesFilterBn', params, {
                headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
            }).then(({ data, status }) => {
                if (status === 200) {
                    this.items = data.data || [];
                    this.totalRows = Number(data.total ?? 0);
                    if (data.per_page) this.perPage = Number(data.per_page);
                    if (data.current_page) this.page = Number(data.current_page);
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            }).catch(err => {
                if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                }
            }).finally(() => {
                this.loading = false;
                this.$swal.close?.();
            });
        },


        /* formatea mientras escribe y sólo agrega el guion final */
        handleRutInput(e) {
            // 1. quitar caracteres no permitidos y pasar a mayúsculas
            const raw = e.target.value.replace(/[^0-9kK]/g, '').toUpperCase();

            // 2. si aún no hay suficiente largo, mostrar tal cual
            if (raw.length <= 1) {
                this.dataForm.rut.value = raw;
                this.dataForm.rut.err = false;
                return;
            }

            // 3. separar cuerpo y dígito verificador
            const cuerpo = raw.slice(0, -1);
            const dv = raw.slice(-1);

            // 4. concatenar con guion (sin puntos)
            this.dataForm.rut.value = `${cuerpo}-${dv}`;
            this.dataForm.rut.err = false;   // limpia error mientras escribe
        },

        formatRut(rut, withDots) {
            let parts = rut.split('-');
            let nums = parts[0].replaceAll('.', '');
            if (withDots) {
                let rutnum = new Intl.NumberFormat('es-CL').format(nums);
                return rutnum + "-" + parts[1];
            } else {
                return nums + "-" + parts[1];
            }
        },

        async getAR() {
            this.$swal({ title: 'Obteniendo cuentas por cobrar' });
            this.$swal.showLoading();
            this.loading = true;

            const params = {
                per_page: this.perPage,
                page: this.page,
                rut: this.dataForm.rut.value,
                tipo: this.dataForm.id_table_type.value || null,
                nroDespacho: this.dataForm.shipping_number.value,
                booking_number: this.dataForm.booking_number.value,
                nroFactura: this.dataForm.document_number.value,
                monto: this.dataForm.amount.value,
                bill_number: this.dataForm.bill_number.value,
                solo_impagos: this.dataForm.only_unpaid.value,
                sort_by: this.sortColumn,
                sort_dir: this.sortDirection,
            };

            try {
                const { data, status } = await axios.post('/api/getReceivablesFilterBn', params, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
                });

                if (status === 200) {
                    this.items = data.data || [];
                    this.totalRows = Number(data.total ?? 0);
                    if (data.per_page) this.perPage = Number(data.per_page);
                    if (data.current_page) this.page = Number(data.current_page);
                } else {
                    this.items = [];
                    this.totalRows = 0;
                }
            } catch (err) {
                if (err.response?.statusText === 'Unauthorized') {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout';
                }
            } finally {
                this.loading = false;
                // cerrabas en mounted; aquí también por si se llama directo
                this.$swal.close?.();
            }
        },

        async exportZip() {
            this.$swal({ title: 'Generando archivo Zip' });
            this.$swal.showLoading();
            try {
                // === A) Traer todos los registros con filtros/orden actuales ===
                const allRows = await this.fetchAllReceivablesForExport();

                // === B) IDs únicos para adjuntos en base al total ===
                const csFeeIds = new Set();
                const paymentIds = new Set();
                allRows.forEach(r => {
                    const feeId = Number(r.id_cs_fee);
                    const payId = Number(r.id_payment);
                    if (feeId) csFeeIds.add(feeId);
                    if (!feeId && payId) paymentIds.add(payId);
                });

                // === C) Armar PDF con todas las filas ===
                const OFICIO_PT = [612, 964];
                const doc = new jsPDF({ orientation: 'landscape', unit: 'pt', format: OFICIO_PT });

                const header = [
                    'CLIENTE', 'RUT', 'REFERENCIA CLIENTE', 'FACTURA', 'NOTA COBRO',
                    'MONTO', 'EMISIÓN', 'ABONO', 'SALDO', 'FECHA DE PAGO'
                ];

                const parseToDate = (v) => {
                    if (!v) return null;
                    if (v instanceof Date) return isNaN(v) ? null : v;
                    if (typeof v === 'string') {
                        const m = v.match(/(\d{4})-(\d{2})-(\d{2})/);
                        if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
                        const t = Date.parse(v); return isNaN(t) ? null : new Date(t);
                    }
                    if (typeof v === 'number') { const ms = v > 1e12 ? v : v * 1000; const d = new Date(ms); return isNaN(d) ? null : d; }
                    return null;
                };
                const fmtEmision = (v) => { const d = parseToDate(v); if (!d) return ''; const dd = String(d.getDate()).padStart(2, '0'); const mm = String(d.getMonth() + 1).padStart(2, '0'); return `${dd}-${mm}-${d.getFullYear()}`; };
                const fmtPago = (v) => { const d = parseToDate(v); if (!d) return ''; const dd = String(d.getDate()).padStart(2, '0'); const meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']; return `${dd}-${meses[d.getMonth()]}`; };
                const fmtMoney = (n, cur) => (n == null || n === '') ? '' : this.formatCurrency(Number(n), cur || 'CLP');

                const body = allRows.map(row => {
                    const cliente = row.client_name || row.nombre_cliente || '';
                    const rut = row.rut || '';
                    const referencia = row.referencia ? row.referencia : row.shipping_clients_reference;
                    const factura = row.bill_number || '';                // Número de factura
                    const notaCobro = row.id_billing_note || '';          // Nota de cobro
                    const monto = fmtMoney(row.monto_con_iva, row.initials);     // Monto (moneda de la fila)
                    const emision = fmtEmision(row.date_origin);             // Fecha creación/origen
                    const abono = fmtMoney(row.value_payment, row.value_payment_initials || row.initials);
                    const saldo = fmtMoney(row.impago_actual_con_iva, row.value_unpaid_initials || row.initials);
                    const fechaPago = fmtPago(row.date);                  // Último abono

                    return [cliente, rut, referencia, factura, notaCobro, monto, emision, abono, saldo, fechaPago];
                });

                autoTable(doc, {
                    head: [header],
                    body,
                    startY: 20,
                    margin: { left: 10, right: 10 },
                    styles: { fontSize: 8.5 },
                    headStyles: { halign: 'center' },
                    columnStyles: {
                        0: { cellWidth: 180 },
                        3: { halign: 'right' }, // FACTURA
                        4: { halign: 'right' }, // NOTA COBRO
                        5: { halign: 'right' }, // MONTO
                        7: { halign: 'right' }, // SALDO
                    },
                });
                const pdfBlob = doc.output('blob');

                // === D) Adjuntos ===
                const { data: attachments } = await axios.post(
                    '/api/attachments',
                    { cs_fee_ids: [...csFeeIds], payment_ids: [...paymentIds] },
                    { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
                );

                // === E) ZIP final ===
                const zip = new JSZip();
                zip.file('balance.pdf', pdfBlob);

                (attachments || []).forEach(f => {
                    const bytes = Uint8Array.from(atob(f.file_base64), c => c.charCodeAt(0));
                    zip.file(f.filename, new Blob([bytes], { type: f.mime_type }));
                });

                const zipBlob = await zip.generateAsync({ type: 'blob' });
                saveAs(zipBlob, 'balance_con_adjuntos.zip');
                this.$swal.close();
            } catch (err) {
                console.error(err);
                this.$swal?.fire('Error', 'No se pudo generar el ZIP', 'error');
            }
        },
        async getClients() {
            this.$swal({
                title: 'Obteniendo clientes',
            });
            this.$swal.showLoading();

            const self = this;

            await axios.get('/api/clients', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }).then(response => {

                if (response.status == 200) {
                    self.clients = response.data.map((clientData) => {
                        // guardamos solo los campos importantes
                        var clientdata = {
                            "id_client": clientData.id_client,
                            "rut": self.formatRut(clientData.rut, true),
                            "filtrar": false,
                            "name": clientData.name
                        };
                        return clientdata;
                    });

                    //self.clientesSelect = response.data.clienteEmpresa;
                    // cerramos el sweet alert en mount
                    // this.$swal.close();
                } else {
                    self.clients = [];
                }
            }).catch(function (error) {

                if (error.response && error.response.statusText === "Unauthorized") {
                    localStorage.removeItem('accessToken');
                    window.location.href = './../../api/auth/logout'
                }
            });
        },


        // Convierte índice de columna (0-based) a letra(s) de Excel (A, B, ..., AA)
        colToLetter(idx) {
            let n = idx + 1, s = '';
            while (n > 0) {
                const mod = (n - 1) % 26;
                s = String.fromCharCode(65 + mod) + s;
                n = Math.floor((n - 1) / 26);
            }
            return s;
        },
        // Para estimar ancho visual del CLP en la hoja
        formatCLPString(n) {
            const num = Number(n);
            const txt = isNaN(num) ? '0' : num.toLocaleString('es-CL', { maximumFractionDigits: 0 });
            return `$${txt}`;
        },
        exportToExcel() {
            try {
                // 1) Columnas visibles (quita 'actions'; si quieres también ocultar 'date_origin', agrégalo aquí)
                const filteredCols = this.columns.filter(col =>
                    col.field !== 'actions'
                    // && col.field !== 'date_origin'
                );

                // 2) Cabecera
                const header = filteredCols.map(col => col.title);

                // 3) Data para Excel (valores reales; 'unpaid_amount' como número)
                const data = this.items.map(item =>
                    filteredCols.map(col => {
                        const key = col.field;
                        if (key === 'unpaid_amount') {
                            const num = Number(item[key]);
                            return isNaN(num) ? 0 : num; // número para SUM
                        }
                        if (key === 'date') {
                            // guardamos el texto simple; si quieres guardar fecha Excel real, necesitarías convertir a serial
                            return this.formatDateOnly(item[key] ?? '');
                        }
                        return item[key] ?? '';
                    })
                );

                // 4) Fila para Total (vacía por ahora)
                const totalRow = new Array(filteredCols.length).fill('');
                const worksheetData = [header, ...data, totalRow];

                // 5) Crear hoja y libro
                const ws = XLSX.utils.aoa_to_sheet(worksheetData);
                const wb = XLSX.utils.book_new();

                // 6) Total y formato CLP en 'unpaid_amount'
                const unpaidIdx = filteredCols.findIndex(c => c.field === 'unpaid_amount');
                if (unpaidIdx !== -1) {
                    const colLetter = this.colToLetter(unpaidIdx);
                    const startRow = 2;                       // datos comienzan en fila 2 (1 = header)
                    const endRow = 1 + this.items.length;   // última fila con datos
                    const totalRowNum = worksheetData.length; // fila del total (1-based)

                    // Etiqueta "Total" en la primera columna (opcional)
                    ws['A' + totalRowNum] = { t: 's', v: 'Total' };

                    // Suma
                    if (this.items.length > 0) {
                        ws[colLetter + totalRowNum] = { t: 'n', f: `SUM(${colLetter}${startRow}:${colLetter}${endRow})` };
                    } else {
                        ws[colLetter + totalRowNum] = { t: 'n', v: 0 };
                    }

                    // Formato CLP para toda esa columna (datos + total)
                    for (let r = startRow; r <= totalRowNum; r++) {
                        const addr = colLetter + r;
                        if (ws[addr]) {
                            ws[addr].t = 'n';
                            ws[addr].z = '"$"#,##0'; // CLP sin decimales
                        }
                    }

                    // Ampliar !ref si hace falta
                    const range = XLSX.utils.decode_range(ws['!ref']);
                    range.e.r = Math.max(range.e.r, totalRowNum - 1);
                    ws['!ref'] = XLSX.utils.encode_range(range);
                }

                // 7) AUTO-AJUSTE DE ANCHO: calculamos el largo máximo “visual” por columna
                //    Usamos un "displayRows" sólo para estimar (cabecera + filas renderizadas)
                const displayRows = this.items.map(item =>
                    filteredCols.map(col => {
                        const key = col.field;
                        if (key === 'unpaid_amount') return this.formatCLPString(item[key]);
                        if (key === 'date') return this.formatDateOnly(item[key]);
                        const v = item[key];
                        return v == null ? '' : String(v);
                    })
                );

                const colWidths = filteredCols.map((col, idx) => {
                    // largo máximo entre header y celdas "display"
                    const headerLen = String(header[idx] ?? '').length;
                    let maxLen = headerLen;

                    for (const row of displayRows) {
                        const cellStr = String(row[idx] ?? '');
                        // si tienes textos muy largos con espacios, puedes considerar dividir por líneas
                        maxLen = Math.max(maxLen, cellStr.length);
                    }

                    // margen + límites para que no quede demasiado angosto/anchísimo
                    const wch = Math.min(Math.max(maxLen + 2, 8), 40);
                    return { wch };
                });

                ws['!cols'] = colWidths;

                // 8) Descargar
                XLSX.utils.book_append_sheet(wb, ws, 'CuentasPorCobrar');
                const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
                const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
                saveAs(blob, 'cuentasPorCobrar.xlsx');
            } catch (error) {
                console.error('Error exportando a Excel:', error);
            }
        },

        // ================================
        //   EXPORTAR A PDF
        // ================================
        exportToPDF() {
            try {
                // Después:
                const OFICIO_PT = [612, 964];
                const doc = new jsPDF({
                    orientation: 'landscape',
                    unit: 'pt',
                    format: OFICIO_PT
                });



                // 2) Creamos la cabecera en base a las columnas
                const header = this.columns
                    .filter(col => col.field !== 'actions')
                    .map(col => col.title);

                // 3) Mapeamos los datos de items
                const data = this.items.map(item => {
                    return this.columns
                        .filter(col => col.field !== 'actions')
                        .map(col => item[col.field] ?? '');
                });

                // 4) Usamos autoTable para generar la tabla en PDF
                autoTable(doc, {
                    head: [header],
                    body: data,
                    startY: 20, // margen superior
                    margin: { left: 10, right: 10 },
                    styles: { fontSize: 8.5 },
                    headStyles: { fillColor: [52, 73, 94] }, // Ejemplo de estilo en cabecera
                });

                // 5) Guardamos el PDF (forzamos la descarga)
                doc.save('cuentasPorCobrar.pdf');
            } catch (error) {
                console.error('Error exportando a PDF:', error);
            }
        },
    },
};
</script>

<style lang="css">
@import 'bootstrap';
@import 'datatables.net-bs5';

body {
    background-color: #f2f5f9;
}

.cont-proveedor {
    height: 300px;
    overflow-y: scroll;
}

.column-email {
    width: 100px;
}
</style>